module.exports = __webpack_public_path__ + "img/section-clientes.17c76b89.jpeg";